module.exports = __webpack_public_path__ + "assets/oslp.15f078df.svg";